import { CmsComponentSwitch } from 'src/cms/CmsComponentSwitch';
import LegacyScripts from 'src/components/LegacyScripts';
import { CmsThemes, ContentfulTemplates } from 'src/lib/constants';
import { TemplateFieldShape } from 'src/lib/prop-types';
import { TemplateWrapper } from 'src/templates';

const propTypes = {
  fields: TemplateFieldShape.isRequired,
};

const PartnerPageTemplate = ({ fields }) => {
  return (
    <TemplateWrapper
      meta-title={fields?.metaTitle}
      meta-description={fields?.metaDescription}
      hasFooterCta={false}
      cmsTheme={CmsThemes.WEB3}
    >
      <div data-testid={ContentfulTemplates.PARTNER_PAGE}>
        <CmsComponentSwitch
          components={fields?.components}
          templatePage={ContentfulTemplates.PARTNER_PAGE}
        />
      </div>
      <LegacyScripts />
    </TemplateWrapper>
  );
};
PartnerPageTemplate.propTypes = propTypes;

export default PartnerPageTemplate;
